import { forwardRef } from "react";

import { AudioFilePicker } from "@shared/components/DataEntry";

import { FormField } from "../FormField";
import { FormAudioFilePickerProps } from "../../types";

export const FormAudioFilePicker = forwardRef<HTMLInputElement, FormAudioFilePickerProps>(({ name, ...props }, ref) => (
  <FormField name={name}>
    <AudioFilePicker ref={ref} {...props} />
  </FormField>
));

FormAudioFilePicker.displayName = "Form.AudioFilePicker";
